


/**
 * Format number of size in bytes to human readed format
 */
export function formatByteSize(size: number): string {
		if (size < 0) return "-";   // unable to format

        if (size < 1024) return size.toString()+" B";

        let kilos = size/1024;
        if (kilos < 1024) return round(kilos).toString()+" kB";

        let megas = kilos/1024.0; //1024.0 - double
		if (megas < 1024) return round(megas).toString()+" MB";

		let gigas = megas/1024.0; //1024.0 - double
		return round(gigas).toString()+" GB";
}

function round(size: number): number {
	return Math.round(size * 100) / 100;
}
